
import { TvProgramByProgDays } from '@rtl/api'
import { Options, Prop, Vue } from 'vue-property-decorator'

import { TvProgramItem } from '@rtl/api'

import TvProgramCard from './TvProgramCard.vue'
import TvProgramModal from './TvProgramModal.vue'

@Options({
  name: 'TvProgramCardList',
  components: {
    TvProgramCard,
    TvProgramModal
  }
})
export default class TvProgramCardList extends Vue {
  @Prop({ type: Array, required: true })
  private tvPrograms!: Array<TvProgramByProgDays & { name?: string }>

  @Prop({ type: Boolean, default: false })
  private showSlider!: boolean

  @Prop({ type: Number, default: 0 })
  private cols!: number

  @Prop({ type: Number, default: 3 })
  readonly itemLength!: number

  programInfo: TvProgramItem | null = null

  showInfo (programInfo: TvProgramItem) {
    this.programInfo = programInfo
  }

  get firstDate () {
    const date = this.tvPrograms.reduce<Date | null>((date, item) => {
      const itemDate = item.progDays?.[0].programs?.[0].progDate ?? null
      return !date || !itemDate || (itemDate <= date) ? itemDate : date
    }, null)

    return date ? new Date(date) : null
  }

  get maxCols () {
    return Math.min(this.cols, this.tvPrograms.length)
  }

  get scrollPaneEl () {
    return this.$el.querySelector('[data-slider-pane]')
  }

  updateHeight () {
    const containerRect = this.scrollPaneEl.getBoundingClientRect()
    let maxHeight = 0

    this.scrollPaneEl.querySelectorAll('.tv-program').forEach((col: Element) => {
      const rect = col.getBoundingClientRect()
      const visible = rect.right > containerRect.left && rect.left < containerRect.right

      if (visible) {
        maxHeight = Math.max(maxHeight, rect.height)
      }
    })

    this.scrollPaneEl.style.height = maxHeight + 'px'
  }

  mounted () {
    this.scrollPaneEl.addEventListener('scroll', this.updateHeight)
    window.addEventListener('resize', this.updateHeight)
    this.updateHeight()
  }

  unmounted () {
    this.scrollPaneEl.removeEventListener('scroll', this.updateHeight)
    window.removeEventListener('resize', this.updateHeight)
  }
}
